import {Theme} from './types'

export const inputStyle = (theme: Theme, hasError: boolean) => ({
  width: '100%',
  height: '48px',
  padding: '0 16px',
  borderRadius: '12px',
  border: `1px solid ${hasError ? '#FF4D4F' : theme.colors.border}`,
  backgroundColor: theme.colors.white,
  fontSize: '15px',
  color: theme.colors.secondary,
  outline: 'none',
  transition: 'all 0.2s',
  boxSizing: 'border-box' as const,
  '&:focus': {
    borderColor: theme.colors.primary,
    boxShadow: `0 0 0 3px ${theme.colors.primary}15`
}
})
